import React, { createContext, useState } from 'react';
import ModalAddNewItem from '@/views/pages/Dictionary/elements/ModalAddNewItem';

export const DictionaryModalContext = createContext({
	modalVisible: false,
	setModalVisible: null,
	editValues: null,
	setEditValues: null,
	setReloadDictionaryCallback: null,
});

const DictionaryModalContextProvider = ({ children }) => {
	const [ modalVisible, setModalVisible ] = useState(false);
	const [ editValues, setEditValues ] = useState(null);
	// const [ reloadDictionaryCallback, setReloadDictionaryCallback ] = useState(()=>{});
	const [ mf, setMf ] = useState({callbackFunction: null});

	const setReloadDictionaryCallback = (mFunction) => {
		if (mFunction) {
			setMf({callbackFunction: mFunction});
		} else if (!mFunction) {
			setMf({callbackFunction: null});
		}
	};

	const tryToReload = () => {
		if (mf.callbackFunction) {
			mf.callbackFunction();
		}
	};

	const context = {
		modalVisible,
		setModalVisible,
		editValues,
		setEditValues,
		setReloadDictionaryCallback,
	};

	return (
		<DictionaryModalContext.Provider value={ context }>
			{ modalVisible && (
				<ModalAddNewItem
					reloadDictionary={ tryToReload }
					modalVisible={ modalVisible }
					setModalVisible={ setModalVisible }
					editValues={ editValues }
					setEditValues={ setEditValues }
				/>
			)}
			{children}
		</DictionaryModalContext.Provider>
	);
};

export default React.memo(DictionaryModalContextProvider);